import { IScheduleViewContext } from './scheduleViewState/scheduleViewContext';

export enum ScheduleViewActionTypes {
	SET_SCHEDULED_PUSHES = 'SET_SCHEDULED_PUSHES',
	REFETCH_SCHEDULES = 'REFETCH_SCHEDULES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_STATUS = 'SET_STATUS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_EDIT = 'SET_ID_FOR_EDIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetScheduledPushes {
	type: ScheduleViewActionTypes.SET_SCHEDULED_PUSHES;
	payload: {
		scheduledPushes: IScheduleViewContext['scheduledPushes'];
		typeOfModalWindow: IScheduleViewContext['typeOfModalWindow'];
	};
}

interface IRefetchSchedules {
	type: ScheduleViewActionTypes.REFETCH_SCHEDULES;
	payload: {
		needRefetchSchedules: IScheduleViewContext['needRefetchSchedules'];
	};
}

interface IChangeSearchString {
	type: ScheduleViewActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IScheduleViewContext['searchString'];
	};
}

interface ISetStatus {
	type: ScheduleViewActionTypes.SET_STATUS;
	payload: {
		status: IScheduleViewContext['status'];
	};
}

interface ISetSortBy {
	type: ScheduleViewActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IScheduleViewContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ScheduleViewActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IScheduleViewContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: ScheduleViewActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IScheduleViewContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ScheduleViewActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IScheduleViewContext['IDForDeletion'];
		typeOfModalWindow: IScheduleViewContext['typeOfModalWindow'];
	};
}

interface ISetIDForEdit {
	type: ScheduleViewActionTypes.SET_ID_FOR_EDIT;
	payload: {
		IDForEdit: IScheduleViewContext['IDForEdit'];
		typeOfModalWindow: IScheduleViewContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ScheduleViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IScheduleViewContext['typeOfModalWindow'];
	};
}

export type TScheduleViewAction =
	| ISetScheduledPushes
	| IRefetchSchedules
	| IChangeSearchString
	| ISetStatus
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForEdit
	| IChangeTypeOfModalWindow;
